import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL?.replace(/\/api\/?$/, '') || 'http://localhost:5001';

const StatsDashboard = () => {
    const [stats, setStats] = useState({
        totalSent: 0,
        totalFailed: 0,
        totalRequests: 0,
        successRate: 0
    });
    const [loading, setLoading] = useState(true);

    const fetchStats = async () => {
        try {
            const response = await axios.get(`${API_URL}/api/whatsapp/stats`);
            setStats(response.data);
            setLoading(false);
        } catch (error) {
            console.error('Erro ao buscar estatísticas:', error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchStats();
        // Atualizar a cada 30 segundos
        const interval = setInterval(fetchStats, 30000);
        return () => clearInterval(interval);
    }, []);

    if (loading) {
        return <div style={{ padding: '20px', textAlign: 'center' }}>Carregando estatísticas...</div>;
    }

    return (
        <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '20px',
            marginBottom: '30px'
        }}>
            <div className="stat-card" style={{ borderLeft: '4px solid #28a745' }}>
                <div className="stat-icon" style={{ color: '#28a745' }}>
                    <i className="fas fa-check-circle"></i>
                </div>
                <div className="stat-info">
                    <h3>{stats.totalSent}</h3>
                    <p>Enviadas Hoje</p>
                </div>
            </div>

            <div className="stat-card" style={{ borderLeft: '4px solid #dc3545' }}>
                <div className="stat-icon" style={{ color: '#dc3545' }}>
                    <i className="fas fa-times-circle"></i>
                </div>
                <div className="stat-info">
                    <h3>{stats.totalFailed}</h3>
                    <p>Falhas</p>
                </div>
            </div>

            <div className="stat-card" style={{ borderLeft: '4px solid #17a2b8' }}>
                <div className="stat-icon" style={{ color: '#17a2b8' }}>
                    <i className="fas fa-chart-line"></i>
                </div>
                <div className="stat-info">
                    <h3>{stats.successRate}%</h3>
                    <p>Taxa de Sucesso</p>
                </div>
            </div>

            <div className="stat-card" style={{ borderLeft: '4px solid #6c757d' }}>
                <div className="stat-icon" style={{ color: '#6c757d' }}>
                    <i className="fas fa-paper-plane"></i>
                </div>
                <div className="stat-info">
                    <h3>{stats.totalRequests}</h3>
                    <p>Total Tentativas</p>
                </div>
            </div>

            <style>{`
                .stat-card {
                    background: white;
                    padding: 20px;
                    border-radius: 8px;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
                    display: flex;
                    align-items: center;
                    gap: 15px;
                    transition: transform 0.2s;
                }
                .stat-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
                }
                .stat-icon {
                    font-size: 2rem;
                    opacity: 0.8;
                }
                .stat-info h3 {
                    margin: 0;
                    font-size: 1.5rem;
                    color: #333;
                }
                .stat-info p {
                    margin: 5px 0 0;
                    color: #666;
                    font-size: 0.9rem;
                }
            `}</style>
        </div>
    );
};

export default StatsDashboard;
